import $ from 'jquery';
import React from 'react';
import OptionPopupView from "views/common/OptionPopupView";
import { createRoot } from "react-dom/client";
import { WorkspaceUsageContent } from '../../components/workspace/WorkspaceUsageContent';

const WorkspaceUsagePopupView = OptionPopupView.extend({

    "pageName": "Workspace Usage Popup",

    initialize: function(options) {
        this._usage = options.usage;
        this._onBuyMore = options.onBuyMore;
        this._i18nModule = options.i18nModule;
        this._reactRoot = null;

        // Create content container for React component
        this.contentContainer$el = $('<div class="workspace-usage-popup-content"></div>');
        this.contentContainer$el.css("width", "calc(100% - 40px)");
        this.contentContainer$el.css("max-width", "600px");

        // Configure OptionPopupView
        const contentView = {};
        contentView.$el = this.contentContainer$el;

        const viewOptions = {
            contentView: contentView,
            contentPosition: "text-not-white",
            addContentAfterEnhancement: true,
            displayTitle: false,
            id: "WorkspaceUsagePopup"
        };

        OptionPopupView.prototype.initialize.call(this, viewOptions);
    },

    onPopupClosed: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
            this._reactRoot = null;
        }
    },

    onBuyMoreTriggered: function() {
        if (this._onBuyMore) {
            this._onBuyMore();
        }
    },

    onCloseTriggered: function() {
        this.close();
    },

    addReactWidget: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
        }

        const root = createRoot(this.contentContainer$el.get(0));

        root.render(
            React.createElement(WorkspaceUsageContent, {
                usage: this._usage,
                onBuyMore: this.onBuyMoreTriggered.bind(this),
                onClose: this.onCloseTriggered.bind(this),
                i18nModule: this._i18nModule
            })
        );

        this._reactRoot = root;
    },

    updateUsage: function(usage) {
        this._usage = usage;
        this.addReactWidget();
    },

    onAfterPageShow: function() {
        this.addReactWidget();
    },

    afterRender: function() {
        OptionPopupView.prototype.afterRender.call(this);
    }
});

export default WorkspaceUsagePopupView;
